export default __webpack_public_path__ + "static/media/16_1.d55da0ea.jpg";